const pxToRem = (num) => {
	return num / parseFloat(getComputedStyle(document.documentElement).fontSize);
}


export default pxToRem